import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Story() {
  return <section className="py-8 md:py-12 bg-[#faf8f6] relative overflow-hidden" data-id="element-477">
      {/* Background blobs */}
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-[#d4a5a5]/10 rounded-full blur-[80px] -z-10" data-id="element-478" />
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-[#9d4b6b]/5 rounded-full blur-[60px] -z-10" data-id="element-479" />

      <div className="max-w-4xl mx-auto px-6" data-id="element-480">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white p-8 md:p-12 rounded-3xl shadow-xl shadow-[#9d4b6b]/5 border border-[#d4a5a5]/20" data-id="element-481">
          <div className="text-center mb-10" data-id="element-482">
            <span className="text-[#9d4b6b] font-medium tracking-widest text-sm uppercase mb-4 block" data-id="element-483">
              Sobre la Autora
            </span>
            <h2 className="text-3xl md:text-4xl font-serif text-[#2d2d2d]" data-id="element-484">
              LA HISTORIA REAL QUE NACIÓ ESTE MÉTODO
            </h2>
          </div>

          <div className="prose prose-lg mx-auto text-[#5a5a5a]" data-id="element-485">
            <p data-id="element-486">
              <strong className="text-[#2d2d2d]" data-id="element-487">
                Carla, la profesional y autora de este libro en formato ebook,
                vivió exactamente lo que tú estás viviendo ahora.
              </strong>
            </p>
            <p data-id="element-488">
              Cada noche lloraba en silencio. Se dormía de espaldas a su esposo,
              sintiendo su presencia física pero su ausencia emocional.
            </p>
            <p data-id="element-489">
              Probó de todo: Consejos. Terapia. Libros. Charlas. Cursos
              comprados en madrugadas de tristeza.
            </p>
            <p className="font-serif text-xl italic text-[#9d4b6b] text-center my-8" data-id="element-490">
              Nada funcionó.
            </p>
            <p data-id="element-491">
              Hasta que comenzó a escribir su dolor. A entenderlo. A separarse
              emocionalmente de él para reencontrarse con ella misma.
            </p>
            <p data-id="element-492">
              Ese fue su "divorcio emocional": no de su esposo, sino del dolor
              que cargaba.
            </p>
            <p data-id="element-493">
              Y desde ese lugar, elaboró un método específico para mujeres
              latinas, desde su experiencia y desde su fe.
            </p>
            <div className="bg-[#faf8f6] p-6 rounded-xl border-l-4 border-[#9d4b6b] mt-8" data-id="element-494">
              <p className="text-[#2d2d2d] font-medium m-0" data-id="element-495">
                Ese método salvó su matrimonio. Y hoy está ayudando a miles de
                mujeres a salvar el suyo.
              </p>
            </div>
          </div>
        </motion.div>

        {/* CTA after Story section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="text-center mt-8" data-id="element-496">
          <p className="text-[#5a5a5a] mb-4 text-lg" data-id="element-497">
            El mismo método que transformó su matrimonio puede transformar el
            tuyo
          </p>
          <CTAButton data-id="element-498">Acceder al Método Ahora</CTAButton>
        </motion.div>
      </div>
    </section>;
}